import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const Blogs = () => {
  const navigate = useNavigate();
  const [blogsArray, setblogsArray] = useState([]);
  const [temp, settemp] = useState(0);

  async function fetchBlogs() {
    try {
      const response = await Axios.get(
        "https://fitness-junction-bots.onrender.com/api/articles"
      );
      setblogsArray(response.data.articles);
      settemp(temp + 1);
    } catch (error) {
      console.error(error);
    }
  }

  function displayBlogs() {
    let blogs_cards = document.getElementById("exercise-cards");
    blogs_cards.innerHTML = "";

    blogsArray.forEach((article) => {
      let blogs_card = document.createElement("div");
      blogs_card.className = "exercise-card";
      // console.log(article.image);
      blogs_card.onclick = () => {
        navigate(`/blogs/${article.s_no}`, {
          state: {
            id: `${article["s_no"]}`,
            title: `${article["title"]}`,
            img: `${article["image"]}`,
            desc: `${article["article"]}`,
          },
        });
      };
      let blogs_image = document.createElement("img");
      blogs_image.className = "blogs-img";
      blogs_image.src = article.image;
      blogs_image.alt = "";
      blogs_card.appendChild(blogs_image);
      let blogs_title = document.createElement("h2");
      blogs_title.className = "exercise-title blog-title";
      let textname = article.title;
      textname = textname.slice(0, 35);
      if (textname.length >= 20) textname = textname.concat(" ...");
      blogs_title.innerText = textname;
      blogs_card.appendChild(blogs_title);
      blogs_cards.appendChild(blogs_card);
    });
  }

  useEffect(() => {
    fetchBlogs();
  }, []);

  useEffect(() => {
    if (blogsArray.length != 0) displayBlogs();
  }, [temp]);
  return (
    <section>
      <div className="exercises-container" id="scroll-to-exercises">
        <h2 className="main-heading">
          Dive Into Our Comprehensive Fitness Hub!
        </h2>
        <div id="exercise-cards" className="exercise-cards"></div>
      </div>
    </section>
  );
};

export default Blogs;
